import { useState } from 'react';
import { Slot } from '@openedx/frontend-base';

import { MobileHeaderShop } from './thervumitra/commerce/HeaderShop';
import { MobileHeaderLanguage } from './thervumitra/HeaderLanguage';
import HeaderSearch from './thervumitra/HeaderSearch';
import { useMessages } from './thervumitra/i18n';
import { catalogUrl, dashboardUrl } from './thervumitra/links';
import VidyaNavLink from './thervumitra/vidya/NavLink';

// The learner dashboard's phone header, in place of frontend-base's mobile
// layout: the menu button, the logo in the middle, notifications and account on
// the right (the mobileRight slot); the menu holds Courses, Discover new, Vidya
// AI, wishlist and cart, and the language; the course search below. Shown below
// 768px, where frontend-base hides its desktop layout (theme: .bm-site-mobile).
const MobileHeader = () => {
  const t = useMessages();
  const [open, setOpen] = useState(false);
  return (
    <div className="bm-site-mobile">
      <div className="bm-site-mobile__row">
        <button type="button" className="bm-site-mobile__menu-btn" aria-label={t.hdrMenu} aria-expanded={open}
          onClick={() => setOpen(o => !o)}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
        </button>
        <div className="bm-site-mobile__logo"><Slot id="org.openedx.frontend.slot.header.mobileCenter.v1" /></div>
        <div className="bm-site-mobile__icons"><Slot id="org.openedx.frontend.slot.header.mobileRight.v1" /></div>
      </div>
      {open && (
        <nav className="bm-site-mobile__menu" aria-label={t.hdrMenu}>
          <a className="nav-link" href={dashboardUrl()}>{t.lhCourses}</a>
          <a className="nav-link" href={catalogUrl('courses')}>{t.hdrDiscover}</a>
          <VidyaNavLink />
          <MobileHeaderShop />
          <MobileHeaderLanguage />
        </nav>
      )}
      <div className="bm-mobile-search"><HeaderSearch /></div>
    </div>
  );
};

export default MobileHeader;
